import { CustomCell } from './components/transport-custom-cell';
import { getNumericOperators } from '../../utils/getNumericOperators';
import { getStringOperators } from '../../utils/getStringOperators';
import { getBooleanOperators } from '../../utils/getBooleanOperators';
import { getSingleSelectOperators } from '../../utils/getSingleSelectOperators';

export const REQUEST_ERROR_MESSAGE = 'Ошибка сервера';

export const TABLE_COLUMNS = (type, filters) => [
	{
		headerName: '#',
		field: 'id',
		width: 100,
		minWidth: 100,
		align: 'center',
		headerAlign: 'center',
		type: 'number',
		cellClassName: 'id',
		filterOperators: getNumericOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: 'Компания',
		field: 'company',
		flex: 2,
		sortable: false,
		filterOperators: getStringOperators(),
	},
	{
		headerName: 'Юр. лицо',
		field: 'legal',
		flex: 2,
		filterOperators: getStringOperators(),
		valueGetter: (value, row) => {
			if (!row.legal) {
				return value;
			}

			return row.legal.name;
		},
	},
	{
		headerName: 'Модель',
		field: 'name',
		flex: 1,
		sortable: false,
		filterOperators: getStringOperators(),
		renderCell: params => CustomCell(params),
	},
	{
		headerName: type === 'cars' ? 'Тип машины' : 'Тип прицепа',
		field: 'type_id',
		flex: 1,
		sortable: false,
		type: 'singleSelect',
		valueOptions: filters.types,
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueGetter: (value, row) => {
			if (!row.type) {
				return '';
			}

			return row.type.id;
		},
	},
	{
		headerName: 'Гос. номер',
		field: 'number',
		width: 150,
		sortable: false,
		filterOperators: getStringOperators(),
	},
	{
		headerName: 'Температурные режимы',
		field: 'mode_id',
		flex: 1,
		sortable: false,
		type: 'singleSelect',
		filterOperators: getSingleSelectOperators(),
		valueOptions: () => {
			return filters.modes.filter($e => $e.id !== 1);
		},
		getOptionValue: value => value?.id,
		getOptionLabel: value => value?.name ?? 'Все',
		valueFormatter: value => {
			if (!value) {
				return '';
			}

			return value.map(mode => mode.mode.name).join(', ');
		},
		valueGetter: (value, row) => {
			if (!row.modes) {
				return '';
			}

			return row.modes;
		},
	},
	{
		headerName: type === 'cars' ? 'Машина аккредитована' : 'Прицеп аккредитован',
		field: 'is_accredited',
		flex: 1,
		sortable: false,
		filterOperators: getBooleanOperators(),
	},
];

export const TRANSPORTS_TABS = [
	{ tab: 'total', text: 'Машины', href: '/quality_block/cars' },
	{ tab: 'total', text: 'Прицепы', href: '/quality_block/trailers' },
];

export const headerTextMap = {
	cars: 'Машины',
	trailers: 'Прицепы',
	default: 'Транспорт',
};
